export default "__VITE_ASSET__1o8GCRlB__"